import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

// 获取渠道列表
export const getChannelList = async () => {
  const { data: res } = await service({
    method: 'get',
    url: store.getters.path.channelList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    }
  })
  if (res.code == 0) {
    return res.data
  }
  return []
}

export const getCountryList = async () => {
  const { data: res } = await service({
    method: 'get',
    url: store.getters.path.CountryList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    }
  })
  if (res.code == 0) {
    return res.data.countryList
  }
  return []
}